import { LRLanguage, LanguageSupport } from '@codemirror/language';
import { FormattedMessage } from 'react-intl';

import { previousFilterFieldParser } from './previous-filterfield-parser.js';
import type { FilterFieldSuggestion } from '../suggestions/Suggestion.js';

const previousFilterFieldLanguage = LRLanguage.define({
  parser: previousFilterFieldParser,
  name: 'FilterFieldOldLang',
});

/** @internal */
export const defaultLogicalOperatorSuggestions: FilterFieldSuggestion[] = [
  { value: 'OR' },
];

/** @internal */
export const defaultComparisonOperatorSuggestions: FilterFieldSuggestion[] = [
  { value: '=' },
  { value: '!=' },
  { value: '<' },
  { value: '<=' },
  { value: '>' },
  { value: '>=' },
  {
    value: 'in (',
    displayValue: 'in',
    details: (
      <FormattedMessage
        defaultMessage="Matches one or more values in a list of values"
        id="sL31KseaKVCE9eh0"
        description="Filter field exists operator description"
      />
    ),
    trailing: ') ',
    cursorBeforeTrailing: true,
  },
  {
    value: 'not in (',
    displayValue: 'not in',
    details: (
      <FormattedMessage
        defaultMessage="Doesn't match one or more values in a list of values"
        id="lp/ioP9LPaFPCj/K"
        description="Filter field exists operator description"
      />
    ),
    trailing: ') ',
    cursorBeforeTrailing: true,
  },
  {
    value: '= *',
    details: (
      <FormattedMessage
        defaultMessage="Exists in any form"
        id="RSp2nSscx4hJgP2P"
        description="Filter field exists operator description"
      />
    ),
  },
  {
    value: '!= *',
    details: (
      <FormattedMessage
        defaultMessage="Doesn't exist in any form"
        id="E1oTbKDAzXJo/hs/"
        description="Filter field not exists operator description"
      />
    ),
  },
];

/** @internal */
export const defaultValueOperatorSuggestions: FilterFieldSuggestion[] = [
  { value: '*', trailing: '', insertionStrategy: 'insert' },
];

/** @internal */
export const previousFilterFieldLanguageExtension = new LanguageSupport(
  previousFilterFieldLanguage,
);
